import PropTypes from 'prop-types';
import { Form, Field } from 'formik';
import { FormattedMessage } from 'react-intl';

import InputField from 'views/shared/InputField';
import SubmitFormButton from 'views/shared/SubmitFormButton';
import Alert from 'views/shared/Alert';
import Button from 'views/shared/Button';

const ResetPasswordRequestFormComponent = ({
  status,
  redirectToLogin,
}) => (
  <div className="container">
    <div className="row">
      <div className="col-12 col-sm-6 offset-sm-3">
        <div className="auth m-auto">
          <h1 className="auth__title">
            <FormattedMessage id="resetPassword.title" />
          </h1>
          <p className="auth__caption">
            <FormattedMessage id="resetPassword.info" />
          </p>
          {status && status.base && (
            <Alert
              className="auth__alert"
              message={status.base}
            />
          )}
          <Form>
            <Field
              fullWidth
              name="email"
              component={InputField}
              id="email"
              type="email"
              label={{ id: 'shared.email' }}
              icon="alert"
            />
            <div className="auth__btns">
              <Button
                text={{ id: 'resetPassword.backToLogin' }}
                kind="back"
                icon="arrow-left"
                className="main-btn--back-center"
                isLink
                href={redirectToLogin}
              />
              <SubmitFormButton
                className="min-w-160"
                text={{ id: 'resetPassword.submit' }}
              />
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
);

ResetPasswordRequestFormComponent.defaultProps = {
  status: undefined,
};

ResetPasswordRequestFormComponent.propTypes = {
  status: PropTypes.shape(),
  redirectToLogin: PropTypes.string.isRequired,
};

export default ResetPasswordRequestFormComponent;
